import type { QueryParamsDto, TierChangePreviewQueryDto } from "@mimber/schema"

/**
 * Query key utilities for members hooks
 * Keys match backend controller method names
 */
export const membersKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["members", "findAll", params] as const)
      : (["members", "findAll"] as const),
  findOne: (memberUuid: string) => ["members", "findOne", memberUuid] as const,
  getMemberDuesSummary: (memberUuid: string) =>
    ["members", "getMemberDuesSummary", memberUuid] as const,
  previewTierChange: (
    memberUuid: string,
    params: Partial<TierChangePreviewQueryDto>
  ) => ["members", "previewTierChange", memberUuid, params] as const,
} as const
